export type CompanyJurisdiction =
  | string
  | {
      id?: number;
      description?: string;
    }
  | null
  | undefined;

export const getJurisdictionLabel = (jurisdiction: CompanyJurisdiction): string => {
  if (!jurisdiction) {
    return '';
  }

  if (typeof jurisdiction === 'string') {
    return jurisdiction;
  }

  return jurisdiction.description ?? '';
};

export const isDelawareJurisdiction = (jurisdiction: CompanyJurisdiction): boolean =>
  getJurisdictionLabel(jurisdiction) === 'Delaware';
